module.exports = __webpack_public_path__ + "img/section8_top.a756594d.png";